import React from 'react';
import { List as AntList } from 'antd';

/**
 * Wrapper component for Ant Design List
 * 
 * This wrapper allows us to easily replace Ant Design in the future without changing all imports.
 * It preserves all Ant Design List functionality and sub-components.
 * 
 * @component
 * @example
 * import { List } from '../GeneralComponents/ui';
 * 
 * <List
 *   dataSource={data}
 *   renderItem={item => (
 *     <List.Item>{item.title}</List.Item>
 *   )}
 * />
 * 
 * @see https://ant.design/components/list/ - Ant Design List documentation
 */
const List = (props) => {
  return <AntList {...props} />;
};

// Preserve List sub-components
List.Item = AntList.Item;
List.Item.Meta = AntList.Item.Meta;

export default List;

